<template>
  <div>
    <div class="content content-intro">
      <div class="player">
        <p>Listen while you read...</p>
        <iframe
          src="https://www.mixcloud.com/widget/iframe/?hide_cover=0&mini=0&feed=%2Fsonos%2Fmellow-morning%2F"
          width="100%"
          height="320"
          frameborder="0"
          allowtransparency="true"
          allow="encrypted-media"
        ></iframe>
      </div>

      <h3>
        The Culpeper Community Garden is a green space that’s both a city park
        and an environmental project. People from the local area all come
        together to tend the grounds, and spend quality time enjoying the sights
        and sounds of nature.
      </h3>
      <p>
        Hafsah sees the community spirit that gardening provides as something
        that people can carry with them: “I would really encourage people to
        support spaces like the Culpeper, learn from what they are doing, share
        this knowledge and put it into practice in your own garden or in a local
        space.”
      </p>
    </div>
    <div class="tile">
      <div v-prlx.mobile="{ reverse: false }" class="prlx-tile-bg">
        <picture>
          <source
            srcset="@/assets/images/body-tile-one-lg.png"
            media="(min-width: 450px)"
          />
          <img src="@/assets/images/about-tile-bg.png" alt="" />
        </picture>
      </div>
      <div
        v-prlx.mobile="{ limit: { min: -5, max: 5 }, reverse: true }"
        class="prlx-tile-img"
      >
        <picture>
         
          <img src="@/assets/images/locations/03-culpeper/body-1.png" alt="" />
        </picture>
      </div>
    </div>
    <div class="desktop-wrapper">
    <div class="desktop-text">
      <div class="content content-break">
      <p>
        The Culpeper is also dedicated to education, and teaching the local
        community about all things green. The garden runs special courses on
        urban habitats, lifecycles, plant structure, mini-beasts, climate
        change, and pond life.
      </p>
    </div>
    <blockquote>
      <div v-prlx.mobile="{ limit: { min: -30, max: 30 } }">
        "An opportunity to see first-hand how simple changes can support our
        natural world"
      </div>
    </blockquote>
    <div class="tile-lower">
      <div v-prlx.mobile="{ reverse: false }" class="prlx-tile-lower-img">
        <picture>
          <source
            srcset="@/assets/images/body-tile-one-lg.png"
            media="(min-width: 450px)"
          />
          <img src="@/assets/images/locations/03-culpeper/body-2.png" alt="" />
        </picture>
      </div>
      <div
        v-prlx.mobile="{ reverse: true, limit: { min: -25, max: 25 } }"
        class="prlx-tile-lower-graphic"
      >
        <picture>
         
          <img src="@/assets/images/location-body-pattern.png" alt="" />
        </picture>
        <div class="highlights">
          <h3>Did you know?</h3>
          <ul>
            <li>
              The garden was named after Nicholas Culpeper, the great
              seventeenth century English herbalist who was based in nearby
              Clerkenwell.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <p>
        Hafsah sees the importance of teaching our communities about what they
        can find on their doorstep: “For visitors, spaces like these highlight a
        problem they may not have even been aware of and gives them an
        opportunity to see first-hand how simple changes can support our natural
        world. You can take what you have learnt home to implement it into your
        own spaces. This can be replicating a planting scheme or a habitat like
        a pond or bug hotel into your green space.”
           </p>

        <p>
          <a href="https://tfl.gov.uk/modes/walking/jubilee-greenway" target="_blank" class="btn walking-btn" >Find a nearby walking route</a>
        </p>
        <img
              src="@/assets/images/locations/03-culpeper/body-2-lg.png"
              alt=""
              class="desktop-picture"
            />
      </div>
      <div class="base-images">
    
            <img
              src="@/assets/images/locations/03-culpeper/body-3-lg.png"
              alt=""
            />
      </div>
    </div>
    <div class="desktop-pictures">
          <img
            src="@/assets/images/locations/03-culpeper/body-1-lg.png"
            alt=""
          />
              <img
        src="@/assets/images/locations/03-culpeper/body-3.png"
        alt=""
        style="margin-bottom: -15px"
      />
     
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Culpeper",
  components: {},
  inject: ["tabControls"],
  props: {},
  mounted: function () {},
  data() {
    return {};
  },
  methods: {},
};
</script>